import { FontUtils, LayoutUtils, MeshUtils, Rectangle3D, VirtualKeyboard3D, VirtualKeyboardUtils } from "@dreamcam/babylon-tools";
import { Env } from "../../settings/Env";
import { XRInputHelper } from "../XRInputHelper";
import { MeshName, UiMeshNames } from "../MeshName";
import { Control } from "@babylonjs/gui/2D/controls/control.js";
export class BroadcastMenuTipsKeyboard {
    get mesh() {
        return this._keyboardMesh;
    }
    // private readonly _maxLength = 5;
    constructor(keyboardMesh, onHideTipsKeyboardCallback, input) {
        this._meshClickListenerHandler = undefined;
        this._addMeshClickListenerHandler = () => {
            if (this._meshClickListenerHandler === undefined) {
                const meshNamesToExclude = [
                    MeshName.broadcastTipsKeyboard,
                    MeshName.lobbyMessengerTipsKeyboardPanel,
                    MeshName.broadcastMessengerTipsKeyboardPanel,
                    MeshName.videoClipMessengerTipsKeyboardPanel,
                ];
                const meshNames = UiMeshNames.filter(x => !meshNamesToExclude.includes(x));
                this._meshClickListenerHandler = XRInputHelper.getInstance()?.addClickOnMeshListener(meshNames, (isHit) => {
                    if (isHit)
                        MeshUtils.hide(this._keyboardMesh);
                });
            }
        };
        this._removeMeshClickListenerHandler = () => {
            if (this._meshClickListenerHandler !== undefined) {
                XRInputHelper.getInstance()?.removeClickOnMeshListener(this._meshClickListenerHandler);
                this._meshClickListenerHandler = undefined;
            }
        };
        this._onHideTipsKeyboardCallback = onHideTipsKeyboardCallback;
        this._keyboardMesh = keyboardMesh;
        // this._keyboardMesh.mesh.material!.transparencyMode = 1;  // ALPHATEST = 1
        this._rootContainer = new Rectangle3D("keyboardContainer");
        this._rootContainer.horizontalAlignment = Control.HORIZONTAL_ALIGNMENT_LEFT;
        this._rootContainer.verticalAlignment = Control.VERTICAL_ALIGNMENT_TOP;
        this._rootContainer.cornerRadius = this._keyboardMesh.m2px(Env.keyboard.cornerRadius);
        this._rootContainer.background = Env.keyboard.background;
        this._rootContainer.thickness = this._keyboardMesh.m2px(Env.keyboard.thickness);
        this._rootContainer.color = Env.keyboard.outlineColor;
        this._keyboardMesh.texture.addControl(this._rootContainer);
        const keyboard = new VirtualKeyboard3D("tipsKeyboard");
        this._rootContainer.addControl(keyboard);
        keyboard.buttonLayout = LayoutUtils.GetButtonLayout(Env.keyboard.buttonLayout, this._keyboardMesh);
        keyboard.textLayout = FontUtils.getAdjustedFontStyle(Env.keyboard.textLayout, this._keyboardMesh);
        keyboard.spacing = this._keyboardMesh.m2px(Env.keyboard.verticalSpacing);
        keyboard.horizontalSpacing = this._keyboardMesh.m2px(Env.keyboard.horizontalSpacing);
        keyboard.verticalAlignment = Control.VERTICAL_ALIGNMENT_CENTER;
        keyboard.cornerRadius = this._keyboardMesh.m2px(Env.keyboard.keyboardCornerRadius);
        keyboard.changeLayout(VirtualKeyboardUtils.GetAdjustedKeyboardLayout(Env.keyboard.tipsLayout(() => this._hide()), this._keyboardMesh));
        keyboard.connect(input);
    }
    show() {
        this._addMeshClickListenerHandler();
        MeshUtils.show(this._keyboardMesh);
    }
    _hide() {
        this._removeMeshClickListenerHandler();
        MeshUtils.hide(this._keyboardMesh);
        this._onHideTipsKeyboardCallback();
    }
}
